<template lang="pug">
  server-data(
    :method="method"
    :success-callback="onSuccessCallback"
    :serialize-data="serializeData"
    no-init
    v-slot="{ init, loading }"
  )
    dv-form(
      ref="form"
      v-bind="$attrs"
      v-on="$listeners"
      :submit-callback="init"
      v-slot="slotFormProps"
    )
      slot(
        v-bind="slotFormProps"
        :loading="loading"
      )
</template>

<script>
import DvForm from './DvForm.vue';

export default {
  components: {
    DvForm,
  },
  props: {
    method: {
      type: Function,
      required: true,
    },
    successCallback: {
      type: Function,
      default: () => null,
    },
    serializeData: {
      type: Function,
      default: (response) => response.data.data,
    },
  },
  methods: {
    onSuccessCallback(data) {
      const { reset } = this.$refs.form;

      this.successCallback({
        data,
        reset,
      });
    },
  },
};
</script>
